var React = require('react');

function Watch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 5c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 22.075 1 16 5.925 5 12 5zm0-1.5a12.441 12.441 0 0 0-8 2.894V1.5C4 .669 4.669 0 5.5 0h13c.831 0 1.5.669 1.5 1.5v4.894A12.458 12.458 0 0 0 12 3.5zm0 25c2.963 0 5.775-1.037 8-2.894V30.5c0 .831-.669 1.5-1.5 1.5h-13c-.831 0-1.5-.669-1.5-1.5v-4.894a12.48 12.48 0 0 0 8 2.894zm3.313-8.144 1.175-1.619a.755.755 0 0 0-.162-1.05l-2.575-1.875V9.999a.753.753 0 0 0-.75-.75h-2a.753.753 0 0 0-.75.75v7.213c0 .238.113.462.306.606l3.706 2.7a.745.745 0 0 0 1.05-.162z"}));
}

Watch.defaultProps = {"viewBox":"0 0 24 32"};

module.exports = Watch;

Watch.default = Watch;
